import { ExternalLink } from "lucide-react";

import { freshdeskTicketUrl } from "@/lib/freshdeskAgentUrl";

export function ApInvoiceFreshdeskTicketLink({
  ticketId,
  variant = "inline",
}: {
  ticketId: number;
  variant?: "inline" | "chip";
}) {
  const chip = variant === "chip";
  return (
    <a
      href={freshdeskTicketUrl(ticketId)}
      target="_blank"
      rel="noreferrer noopener"
      className={
        chip
          ? "inline-flex items-center gap-1 rounded-md border border-slate-200 bg-white px-2 py-0.5 text-xs font-medium text-slate-700 hover:border-brand-300 hover:text-brand-700"
          : "inline-flex items-center gap-1 font-medium text-brand-600 hover:text-brand-700"
      }
      aria-label={`Open Freshdesk ticket ${ticketId}`}
    >
      {chip ? `Freshdesk #${ticketId}` : `Freshdesk ticket ${ticketId}`}
      <ExternalLink className={chip ? "h-3.5 w-3.5" : "h-3 w-3"} aria-hidden />
    </a>
  );
}
